/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as o from "react";
import { GridContext as n } from "../../utils/GridContext.mjs";
import { useEditCellClientTdProps as c } from "./useEditCellClientTdProps.mjs";
import { useLegacyCellProps as s } from "../hooks.mjs";
import { cloneReactElement as r } from "../../utils/index.mjs";
const f = (e) => {
  const i = o.useContext(n), t = c(e.cellProps), l = s(e.cellProps);
  return e.isCustom && (i.isClient || e.isClient) ? r(e.children, {
    // pass down to tdProps for client templates
    tdProps: { ...e.tdProps, ...t },
    ...l
  }) : e.children && r(e.children, {
    ...t
  });
};
export {
  f as GridEditCellServerContainer
};
